<div class="select">
    <div
        *ngIf="labels"
        class="select-label">
        Font
    </div>
    <ui-select
        #fontFamilySelect
        id="font-family"
        [useTargetWidth]="true"
        [uiTooltip]="selectedFontFamily?.name || ''"
        [uiTooltipDisabled]="!selectedFontFamily?.name"
        [selected]="selectedFontFamilyId === '$mixed' ? 'Mixed' : selectedFontFamily"
        [placeholder]="fontFamilyPlaceholder"
        [backdropCss]="'prevent-text-blur'"
        [disabled]="disabled || filteredFontFamilies.length === 0"
        (onOpen)="selectOpen()">
        <div (mouseleave)="onMouseLeave()">
            <ng-container *ngIf="selectedFontFamilyId === '$mixed'">
                <ui-option
                    [value]="'Mixed'"
                    [selected]="true">
                    Mixed
                </ui-option>
                <div class="option-divider"></div>
            </ng-container>
            <ui-option
                *ngFor="let fontFamily of filteredFontFamilies || []"
                (mouseover)="onHoverFontFamily(fontFamily)"
                (mousedown)="mousedown.emit($event)"
                (click)="onFontFamilyChanged(fontFamily)"
                [value]="fontFamily"
                >{{ fontFamily.name }}</ui-option
            >
            <div class="buttons">
                <toolbar-button
                    icon="settings"
                    width="100%"
                    [iconSize]="14"
                    (click)="openFontManager()">
                </toolbar-button>
            </div>
        </div>
    </ui-select>
</div>
<div class="select">
    <div
        *ngIf="labels"
        class="select-label">
        Style
    </div>
    <ui-select
        #fontStyleSelect
        id="font-style"
        [useTargetWidth]="true"
        [uiTooltip]="selectedFontStyle?.name || ''"
        [uiTooltipDisabled]="!selectedFontStyle?.name"
        [placeholder]="fontStylePlaceholder"
        [selected]="selectedFontStyleId === '$mixed' ? 'Mixed' : selectedFontStyle"
        [disabled]="disabled || !filteredFontFamilies"
        [backdropCss]="'prevent-text-blur'"
        (onOpen)="selectOpen()">
        <div (mouseleave)="onMouseLeave()">
            <ng-container *ngIf="selectedFontStyleId === '$mixed'">
                <ui-option
                    [value]="'Mixed'"
                    [selected]="true">
                    Mixed
                </ui-option>
                <div class="option-divider"></div>
            </ng-container>
            <ng-container *ngIf="selectedFontFamily">
                <ui-option
                    *ngFor="
                        let fontStyle of selectedFontFamily.fontStyles || []
                            | sortArray: { weight: 'asc' }
                    "
                    (mouseover)="onHoverFontStyle(fontStyle)"
                    (mousedown)="mousedown.emit($event)"
                    (click)="onFontStyleChanged(fontStyle)"
                    [value]="fontStyle"
                    >{{ fontStyle.name }}</ui-option
                >
            </ng-container>
            <div class="buttons">
                <toolbar-button
                    icon="settings"
                    width="100%"
                    [iconSize]="14"
                    (click)="openFontManager()">
                </toolbar-button>
            </div>
        </div>
    </ui-select>
</div>
